<template>
  <section class="body--main">
    <div class="container-fluid">
      <div class="container">
        <nav aria-label="breadcrumb" class="hide__on_mobile">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Accueil</li>
            <li class="breadcrumb-item">NSIA Voyage</li>
            <li class="breadcrumb-item active" aria-current="page">
              Souscrire à Assurance Voyage
            </li>
          </ol>
        </nav>
        <div class="page__header--info">
          <div class="page__header--info__text">
            Souscrire à Assurance Voyage
          </div>
          <svg
            v-if="node == '0'"
            @click="saveForLate()"
            class="page__header--info__icon hide__btn--large"
            width="292"
            height="53"
            viewBox="0 0 292 53"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M26.333 20.7391C26.1562 20.7391 25.9866 20.8093 25.8616 20.9344C25.7366 21.0594 25.6663 21.229 25.6663 21.4058V30.7391C25.6663 30.9159 25.7366 31.0855 25.8616 31.2105C25.9866 31.3355 26.1562 31.4058 26.333 31.4058H35.6663C35.8432 31.4058 36.0127 31.3355 36.1377 31.2105C36.2628 31.0855 36.333 30.9159 36.333 30.7391V23.6819L33.3902 20.7391H26.333ZM24.9188 19.9915C25.2939 19.6165 25.8026 19.4058 26.333 19.4058H33.6663C33.8432 19.4058 34.0127 19.476 34.1377 19.601L37.4711 22.9344C37.5961 23.0594 37.6663 23.229 37.6663 23.4058V30.7391C37.6663 31.2695 37.4556 31.7782 37.0806 32.1533C36.7055 32.5284 36.1968 32.7391 35.6663 32.7391H26.333C25.8026 32.7391 25.2939 32.5284 24.9188 32.1533C24.5437 31.7782 24.333 31.2695 24.333 30.7391V21.4058C24.333 20.8753 24.5437 20.3666 24.9188 19.9915Z"
              fill="#002A85"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M26.9997 26.7391C26.9997 26.3709 27.2982 26.0724 27.6663 26.0724H34.333C34.7012 26.0724 34.9997 26.3709 34.9997 26.7391V32.0724C34.9997 32.4406 34.7012 32.7391 34.333 32.7391C33.9648 32.7391 33.6663 32.4406 33.6663 32.0724V27.4058H28.333V32.0724C28.333 32.4406 28.0345 32.7391 27.6663 32.7391C27.2982 32.7391 26.9997 32.4406 26.9997 32.0724V26.7391Z"
              fill="#002A85"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M27.6663 19.4058C28.0345 19.4058 28.333 19.7042 28.333 20.0724V22.7391H32.9997C33.3679 22.7391 33.6663 23.0376 33.6663 23.4058C33.6663 23.774 33.3679 24.0724 32.9997 24.0724H27.6663C27.2982 24.0724 26.9997 23.774 26.9997 23.4058V20.0724C26.9997 19.7042 27.2982 19.4058 27.6663 19.4058Z"
              fill="#002A85"
            />
            <path
              d="M55.4297 28.9709C55.4297 29.9866 55.0625 30.7834 54.3281 31.3616C53.5938 31.9397 52.5807 32.2288 51.2891 32.2288C49.9974 32.2288 48.9401 32.0282 48.1172 31.6272V29.8616C48.638 30.1064 49.1901 30.2991 49.7734 30.4397C50.362 30.5803 50.9089 30.6506 51.4141 30.6506C52.1536 30.6506 52.6979 30.51 53.0469 30.2288C53.401 29.9475 53.5781 29.5699 53.5781 29.0959C53.5781 28.6689 53.4167 28.3069 53.0938 28.01C52.7708 27.7131 52.1042 27.3616 51.0938 26.9553C50.0521 26.5334 49.3177 26.0517 48.8906 25.51C48.4635 24.9683 48.25 24.3173 48.25 23.5569C48.25 22.6038 48.5885 21.8538 49.2656 21.3069C49.9427 20.76 50.8516 20.4866 51.9922 20.4866C53.0859 20.4866 54.1745 20.7262 55.2578 21.2053L54.6641 22.7288C53.6484 22.3017 52.7422 22.0881 51.9453 22.0881C51.3411 22.0881 50.8828 22.2209 50.5703 22.4866C50.2578 22.747 50.1016 23.0933 50.1016 23.5256C50.1016 23.8225 50.1641 24.0777 50.2891 24.2913C50.4141 24.4996 50.6198 24.6975 50.9062 24.885C51.1927 25.0725 51.7083 25.3199 52.4531 25.6272C53.2917 25.9762 53.9062 26.3017 54.2969 26.6038C54.6875 26.9058 54.974 27.247 55.1562 27.6272C55.3385 28.0074 55.4297 28.4553 55.4297 28.9709ZM63.2516 32.0725L62.8844 30.8694H62.8219C62.4052 31.3954 61.9859 31.7548 61.5641 31.9475C61.1422 32.135 60.6005 32.2288 59.9391 32.2288C59.0901 32.2288 58.426 31.9996 57.9469 31.5413C57.4729 31.0829 57.2359 30.4345 57.2359 29.5959C57.2359 28.7053 57.5667 28.0334 58.2281 27.5803C58.8896 27.1272 59.8974 26.8798 61.2516 26.8381L62.7437 26.7913V26.3303C62.7437 25.7782 62.6135 25.3668 62.3531 25.0959C62.0979 24.8199 61.6995 24.6819 61.1578 24.6819C60.7151 24.6819 60.2906 24.747 59.8844 24.8772C59.4781 25.0074 59.0875 25.1611 58.7125 25.3381L58.1187 24.0256C58.5875 23.7808 59.1005 23.5959 59.6578 23.4709C60.2151 23.3407 60.7411 23.2756 61.2359 23.2756C62.3349 23.2756 63.163 23.5152 63.7203 23.9944C64.2828 24.4736 64.5641 25.2262 64.5641 26.2522V32.0725H63.2516ZM60.5172 30.8225C61.1839 30.8225 61.7177 30.6376 62.1187 30.2678C62.525 29.8928 62.7281 29.3694 62.7281 28.6975V27.9475L61.6187 27.9944C60.7542 28.0256 60.124 28.1715 59.7281 28.4319C59.3375 28.6871 59.1422 29.0803 59.1422 29.6116C59.1422 29.997 59.2568 30.2965 59.4859 30.51C59.7151 30.7183 60.0589 30.8225 60.5172 30.8225ZM73.6203 32.0725L73.3625 30.9397H73.2687C73.0135 31.3407 72.649 31.6558 72.175 31.885C71.7062 32.1142 71.1698 32.2288 70.5656 32.2288C69.5187 32.2288 68.7375 31.9683 68.2219 31.4475C67.7062 30.9267 67.4484 30.1376 67.4484 29.0803V23.4319H69.3V28.76C69.3 29.4215 69.4354 29.9189 69.7062 30.2522C69.9771 30.5803 70.4016 30.7444 70.9797 30.7444C71.7505 30.7444 72.3156 30.5152 72.675 30.0569C73.0396 29.5933 73.2219 28.8199 73.2219 27.7366V23.4319H75.0656V32.0725H73.6203ZM80.0516 32.0725L76.7703 23.4319H78.7078L80.4656 28.4553C80.7677 29.2991 80.95 29.9814 81.0125 30.5022H81.075C81.1219 30.1272 81.3042 29.4449 81.6219 28.4553L83.3797 23.4319H85.3328L82.0359 32.0725H80.0516ZM90.8187 32.2288C89.475 32.2288 88.4229 31.8381 87.6625 31.0569C86.9073 30.2704 86.5297 29.1897 86.5297 27.8147C86.5297 26.4032 86.8812 25.2939 87.5844 24.4866C88.2875 23.6793 89.2536 23.2756 90.4828 23.2756C91.6234 23.2756 92.5245 23.622 93.1859 24.3147C93.8474 25.0074 94.1781 25.9605 94.1781 27.1741V28.1663H88.4203C88.4464 29.0048 88.6729 29.6506 89.1 30.1038C89.5271 30.5517 90.1286 30.7756 90.9047 30.7756C91.4151 30.7756 91.8891 30.7288 92.3266 30.635C92.7693 30.5361 93.2432 30.3746 93.7484 30.1506V31.6428C93.3005 31.8564 92.8474 32.0074 92.3891 32.0959C91.9307 32.1845 91.4073 32.2288 90.8187 32.2288ZM90.4828 24.6663C89.8995 24.6663 89.4307 24.8512 89.0766 25.2209C88.7276 25.5907 88.5193 26.1298 88.4516 26.8381H92.3734C92.363 26.1246 92.1911 25.5855 91.8578 25.2209C91.5245 24.8512 91.0661 24.6663 90.4828 24.6663ZM103.961 23.4319V24.4397L102.484 24.7131C102.62 24.8954 102.732 25.1194 102.82 25.385C102.909 25.6506 102.953 25.9319 102.953 26.2288C102.953 27.1194 102.646 27.8199 102.031 28.3303C101.417 28.8407 100.57 29.0959 99.4922 29.0959C99.2161 29.0959 98.9661 29.0751 98.7422 29.0334C98.3464 29.2782 98.1484 29.5647 98.1484 29.8928C98.1484 30.0907 98.2396 30.2392 98.4219 30.3381C98.6094 30.4371 98.9505 30.4866 99.4453 30.4866H100.953C101.906 30.4866 102.63 30.6897 103.125 31.0959C103.62 31.5022 103.867 32.0881 103.867 32.8538C103.867 33.8329 103.464 34.5881 102.656 35.1194C101.849 35.6506 100.682 35.9163 99.1562 35.9163C97.9792 35.9163 97.0807 35.7079 96.4609 35.2913C95.8411 34.8746 95.5312 34.2808 95.5312 33.51C95.5312 32.9788 95.6979 32.5308 96.0312 32.1663C96.3698 31.8069 96.8411 31.5569 97.4453 31.4163C97.2005 31.3121 96.9974 31.1454 96.8359 30.9163C96.6797 30.6819 96.6016 30.4371 96.6016 30.1819C96.6016 29.859 96.6927 29.5855 96.875 29.3616C97.0573 29.1376 97.3281 28.9163 97.6875 28.6975C97.2396 28.5048 96.875 28.1923 96.5938 27.76C96.3177 27.3225 96.1797 26.8121 96.1797 26.2288C96.1797 25.2913 96.474 24.5647 97.0625 24.0491C97.6562 23.5334 98.5 23.2756 99.5938 23.2756C99.8385 23.2756 100.094 23.2939 100.359 23.3303C100.63 23.3616 100.833 23.3954 100.969 23.4319H103.961ZM97.1719 33.4163C97.1719 33.8121 97.349 34.1168 97.7031 34.3303C98.0625 34.5439 98.5651 34.6506 99.2109 34.6506C100.211 34.6506 100.956 34.5074 101.445 34.2209C101.935 33.9345 102.18 33.5543 102.18 33.0803C102.18 32.7053 102.044 32.4371 101.773 32.2756C101.508 32.1194 101.01 32.0413 100.281 32.0413H98.8906C98.3646 32.0413 97.9453 32.1637 97.6328 32.4084C97.3255 32.6584 97.1719 32.9944 97.1719 33.4163ZM97.9609 26.2288C97.9609 26.7704 98.099 27.1871 98.375 27.4788C98.6562 27.7704 99.0573 27.9163 99.5781 27.9163C100.641 27.9163 101.172 27.3486 101.172 26.2131C101.172 25.6506 101.039 25.2183 100.773 24.9163C100.513 24.609 100.115 24.4553 99.5781 24.4553C99.0469 24.4553 98.6432 24.6064 98.3672 24.9084C98.0964 25.2105 97.9609 25.6506 97.9609 26.2288ZM111.377 32.0725L111.009 30.8694H110.947C110.53 31.3954 110.111 31.7548 109.689 31.9475C109.267 32.135 108.726 32.2288 108.064 32.2288C107.215 32.2288 106.551 31.9996 106.072 31.5413C105.598 31.0829 105.361 30.4345 105.361 29.5959C105.361 28.7053 105.692 28.0334 106.353 27.5803C107.015 27.1272 108.022 26.8798 109.377 26.8381L110.869 26.7913V26.3303C110.869 25.7782 110.739 25.3668 110.478 25.0959C110.223 24.8199 109.824 24.6819 109.283 24.6819C108.84 24.6819 108.416 24.747 108.009 24.8772C107.603 25.0074 107.213 25.1611 106.838 25.3381L106.244 24.0256C106.713 23.7808 107.226 23.5959 107.783 23.4709C108.34 23.3407 108.866 23.2756 109.361 23.2756C110.46 23.2756 111.288 23.5152 111.845 23.9944C112.408 24.4736 112.689 25.2262 112.689 26.2522V32.0725H111.377ZM108.642 30.8225C109.309 30.8225 109.843 30.6376 110.244 30.2678C110.65 29.8928 110.853 29.3694 110.853 28.6975V27.9475L109.744 27.9944C108.879 28.0256 108.249 28.1715 107.853 28.4319C107.463 28.6871 107.267 29.0803 107.267 29.6116C107.267 29.997 107.382 30.2965 107.611 30.51C107.84 30.7183 108.184 30.8225 108.642 30.8225ZM120.034 23.2756C120.404 23.2756 120.709 23.3017 120.948 23.3538L120.769 25.0647C120.508 25.0022 120.238 24.9709 119.956 24.9709C119.222 24.9709 118.626 25.2105 118.167 25.6897C117.714 26.1689 117.488 26.7913 117.488 27.5569V32.0725H115.652V23.4319H117.089L117.331 24.9553H117.425C117.711 24.4397 118.084 24.0308 118.542 23.7288C119.006 23.4267 119.503 23.2756 120.034 23.2756ZM125.872 32.2288C124.794 32.2288 123.953 31.8381 123.348 31.0569C122.744 30.2756 122.442 29.1793 122.442 27.7678C122.442 26.3512 122.747 25.2496 123.356 24.4631C123.971 23.6715 124.82 23.2756 125.903 23.2756C127.039 23.2756 127.903 23.6949 128.497 24.5334H128.591C128.502 23.9137 128.458 23.4241 128.458 23.0647V19.9163H130.302V32.0725H128.864L128.544 30.9397H128.458C127.869 31.7991 127.007 32.2288 125.872 32.2288ZM126.364 30.7444C127.119 30.7444 127.669 30.5334 128.012 30.1116C128.356 29.6845 128.533 28.9944 128.544 28.0413V27.7834C128.544 26.6949 128.367 25.9215 128.012 25.4631C127.658 25.0048 127.104 24.7756 126.348 24.7756C125.703 24.7756 125.205 25.0387 124.856 25.5647C124.507 26.0855 124.333 26.8303 124.333 27.7991C124.333 28.7574 124.502 29.4892 124.841 29.9944C125.179 30.4944 125.687 30.7444 126.364 30.7444ZM137.1 32.2288C135.756 32.2288 134.704 31.8381 133.944 31.0569C133.189 30.2704 132.811 29.1897 132.811 27.8147C132.811 26.4032 133.162 25.2939 133.866 24.4866C134.569 23.6793 135.535 23.2756 136.764 23.2756C137.905 23.2756 138.806 23.622 139.467 24.3147C140.129 25.0074 140.459 25.9605 140.459 27.1741V28.1663H134.702C134.728 29.0048 134.954 29.6506 135.381 30.1038C135.808 30.5517 136.41 30.7756 137.186 30.7756C137.696 30.7756 138.17 30.7288 138.608 30.635C139.051 30.5361 139.524 30.3746 140.03 30.1506V31.6428C139.582 31.8564 139.129 32.0074 138.67 32.0959C138.212 32.1845 137.689 32.2288 137.1 32.2288ZM136.764 24.6663C136.181 24.6663 135.712 24.8512 135.358 25.2209C135.009 25.5907 134.801 26.1298 134.733 26.8381H138.655C138.644 26.1246 138.472 25.5855 138.139 25.2209C137.806 24.8512 137.347 24.6663 136.764 24.6663ZM147.328 23.2756C147.698 23.2756 148.003 23.3017 148.242 23.3538L148.062 25.0647C147.802 25.0022 147.531 24.9709 147.25 24.9709C146.516 24.9709 145.919 25.2105 145.461 25.6897C145.008 26.1689 144.781 26.7913 144.781 27.5569V32.0725H142.945V23.4319H144.383L144.625 24.9553H144.719C145.005 24.4397 145.378 24.0308 145.836 23.7288C146.299 23.4267 146.797 23.2756 147.328 23.2756ZM159.191 32.2288C158.097 32.2288 157.248 31.8355 156.644 31.0491H156.534C156.607 31.7782 156.644 32.2209 156.644 32.3772V35.9163H154.808V23.4319H156.292C156.334 23.5933 156.42 23.9788 156.55 24.5881H156.644C157.217 23.7131 158.076 23.2756 159.222 23.2756C160.3 23.2756 161.139 23.6663 161.738 24.4475C162.342 25.2288 162.644 26.3251 162.644 27.7366C162.644 29.148 162.336 30.2496 161.722 31.0413C161.113 31.8329 160.269 32.2288 159.191 32.2288ZM158.745 24.7756C158.016 24.7756 157.482 24.9892 157.144 25.4163C156.81 25.8433 156.644 26.5256 156.644 27.4631V27.7366C156.644 28.7887 156.81 29.5517 157.144 30.0256C157.477 30.4944 158.021 30.7288 158.777 30.7288C159.412 30.7288 159.902 30.4683 160.245 29.9475C160.589 29.4267 160.761 28.6845 160.761 27.7209C160.761 26.7522 160.589 26.0204 160.245 25.5256C159.907 25.0256 159.407 24.7756 158.745 24.7756ZM172.841 27.7366C172.841 29.148 172.479 30.2496 171.755 31.0413C171.031 31.8329 170.023 32.2288 168.731 32.2288C167.924 32.2288 167.21 32.0465 166.591 31.6819C165.971 31.3173 165.494 30.7939 165.161 30.1116C164.828 29.4293 164.661 28.6376 164.661 27.7366C164.661 26.3355 165.02 25.2418 165.739 24.4553C166.458 23.6689 167.471 23.2756 168.778 23.2756C170.028 23.2756 171.018 23.6793 171.747 24.4866C172.476 25.2887 172.841 26.372 172.841 27.7366ZM166.552 27.7366C166.552 29.7314 167.289 30.7288 168.762 30.7288C170.221 30.7288 170.95 29.7314 170.95 27.7366C170.95 25.7626 170.216 24.7756 168.747 24.7756C167.976 24.7756 167.416 25.0308 167.067 25.5413C166.723 26.0517 166.552 26.7834 166.552 27.7366ZM181.452 32.0725L181.194 30.9397H181.1C180.845 31.3407 180.48 31.6558 180.006 31.885C179.537 32.1142 179.001 32.2288 178.397 32.2288C177.35 32.2288 176.569 31.9683 176.053 31.4475C175.537 30.9267 175.28 30.1376 175.28 29.0803V23.4319H177.131V28.76C177.131 29.4215 177.267 29.9189 177.537 30.2522C177.808 30.5803 178.233 30.7444 178.811 30.7444C179.582 30.7444 180.147 30.5152 180.506 30.0569C180.871 29.5933 181.053 28.8199 181.053 27.7366V23.4319H182.897V32.0725H181.452ZM190.297 23.2756C190.667 23.2756 190.971 23.3017 191.211 23.3538L191.031 25.0647C190.771 25.0022 190.5 24.9709 190.219 24.9709C189.484 24.9709 188.888 25.2105 188.43 25.6897C187.977 26.1689 187.75 26.7913 187.75 27.5569V32.0725H185.914V23.4319H187.352L187.594 24.9553H187.688C187.974 24.4397 188.346 24.0308 188.805 23.7288C189.268 23.4267 189.766 23.2756 190.297 23.2756ZM202.159 32.2288C201.066 32.2288 200.217 31.8355 199.613 31.0491H199.503C199.576 31.7782 199.613 32.2209 199.613 32.3772V35.9163H197.777V23.4319H199.261C199.303 23.5933 199.389 23.9788 199.519 24.5881H199.613C200.185 23.7131 201.045 23.2756 202.191 23.2756C203.269 23.2756 204.107 23.6663 204.706 24.4475C205.31 25.2288 205.613 26.3251 205.613 27.7366C205.613 29.148 205.305 30.2496 204.691 31.0413C204.081 31.8329 203.238 32.2288 202.159 32.2288ZM201.714 24.7756C200.985 24.7756 200.451 24.9892 200.113 25.4163C199.779 25.8433 199.613 26.5256 199.613 27.4631V27.7366C199.613 28.7887 199.779 29.5517 200.113 30.0256C200.446 30.4944 200.99 30.7288 201.745 30.7288C202.381 30.7288 202.87 30.4683 203.214 29.9475C203.558 29.4267 203.73 28.6845 203.73 27.7209C203.73 26.7522 203.558 26.0204 203.214 25.5256C202.876 25.0256 202.376 24.7756 201.714 24.7756ZM209.981 32.0725H208.145V19.9163H209.981V32.0725ZM219.108 32.0725L218.85 30.9397H218.756C218.501 31.3407 218.136 31.6558 217.663 31.885C217.194 32.1142 216.657 32.2288 216.053 32.2288C215.006 32.2288 214.225 31.9683 213.709 31.4475C213.194 30.9267 212.936 30.1376 212.936 29.0803V23.4319H214.788V28.76C214.788 29.4215 214.923 29.9189 215.194 30.2522C215.465 30.5803 215.889 30.7444 216.467 30.7444C217.238 30.7444 217.803 30.5152 218.163 30.0569C218.527 29.5933 218.709 28.8199 218.709 27.7366V23.4319H220.553V32.0725H219.108ZM229.375 29.6116C229.375 30.4553 229.068 31.1038 228.453 31.5569C227.839 32.0048 226.958 32.2288 225.812 32.2288C224.661 32.2288 223.737 32.0543 223.039 31.7053V30.1194C224.055 30.5881 225 30.8225 225.875 30.8225C227.005 30.8225 227.57 30.4814 227.57 29.7991C227.57 29.5803 227.508 29.398 227.383 29.2522C227.258 29.1064 227.052 28.9553 226.766 28.7991C226.479 28.6428 226.081 28.4657 225.57 28.2678C224.576 27.8824 223.901 27.497 223.547 27.1116C223.198 26.7262 223.023 26.2262 223.023 25.6116C223.023 24.872 223.32 24.2991 223.914 23.8928C224.513 23.4814 225.326 23.2756 226.352 23.2756C227.367 23.2756 228.328 23.4814 229.234 23.8928L228.641 25.2756C227.708 24.8902 226.924 24.6975 226.289 24.6975C225.32 24.6975 224.836 24.9736 224.836 25.5256C224.836 25.7965 224.961 26.0256 225.211 26.2131C225.466 26.4006 226.018 26.6584 226.867 26.9866C227.581 27.2626 228.099 27.5152 228.422 27.7444C228.745 27.9736 228.984 28.2392 229.141 28.5413C229.297 28.8381 229.375 29.1949 229.375 29.6116ZM239.542 30.7444C239.99 30.7444 240.438 30.6741 240.886 30.5334V31.9163C240.683 32.0048 240.42 32.0777 240.097 32.135C239.779 32.1975 239.448 32.2288 239.105 32.2288C237.365 32.2288 236.495 31.3121 236.495 29.4788V24.8225H235.316V24.01L236.581 23.3381L237.206 21.51H238.339V23.4319H240.8V24.8225H238.339V29.4475C238.339 29.8902 238.448 30.2183 238.667 30.4319C238.891 30.6402 239.183 30.7444 239.542 30.7444ZM248.427 32.0725L248.059 30.8694H247.997C247.58 31.3954 247.161 31.7548 246.739 31.9475C246.317 32.135 245.776 32.2288 245.114 32.2288C244.265 32.2288 243.601 31.9996 243.122 31.5413C242.648 31.0829 242.411 30.4345 242.411 29.5959C242.411 28.7053 242.742 28.0334 243.403 27.5803C244.065 27.1272 245.072 26.8798 246.427 26.8381L247.919 26.7913V26.3303C247.919 25.7782 247.789 25.3668 247.528 25.0959C247.273 24.8199 246.874 24.6819 246.333 24.6819C245.89 24.6819 245.466 24.747 245.059 24.8772C244.653 25.0074 244.262 25.1611 243.887 25.3381L243.294 24.0256C243.762 23.7808 244.276 23.5959 244.833 23.4709C245.39 23.3407 245.916 23.2756 246.411 23.2756C247.51 23.2756 248.338 23.5152 248.895 23.9944C249.458 24.4736 249.739 25.2262 249.739 26.2522V32.0725H248.427ZM245.692 30.8225C246.359 30.8225 246.893 30.6376 247.294 30.2678C247.7 29.8928 247.903 29.3694 247.903 28.6975V27.9475L246.794 27.9944C245.929 28.0256 245.299 28.1715 244.903 28.4319C244.512 28.6871 244.317 29.0803 244.317 29.6116C244.317 29.997 244.432 30.2965 244.661 30.51C244.89 30.7183 245.234 30.8225 245.692 30.8225ZM257.084 23.2756C257.454 23.2756 257.759 23.3017 257.998 23.3538L257.819 25.0647C257.558 25.0022 257.288 24.9709 257.006 24.9709C256.272 24.9709 255.676 25.2105 255.217 25.6897C254.764 26.1689 254.538 26.7913 254.538 27.5569V32.0725H252.702V23.4319H254.139L254.381 24.9553H254.475C254.761 24.4397 255.134 24.0308 255.592 23.7288C256.056 23.4267 256.553 23.2756 257.084 23.2756ZM262.922 32.2288C261.844 32.2288 261.003 31.8381 260.398 31.0569C259.794 30.2756 259.492 29.1793 259.492 27.7678C259.492 26.3512 259.797 25.2496 260.406 24.4631C261.021 23.6715 261.87 23.2756 262.953 23.2756C264.089 23.2756 264.953 23.6949 265.547 24.5334H265.641C265.552 23.9137 265.508 23.4241 265.508 23.0647V19.9163H267.352V32.0725H265.914L265.594 30.9397H265.508C264.919 31.7991 264.057 32.2288 262.922 32.2288ZM263.414 30.7444C264.169 30.7444 264.719 30.5334 265.062 30.1116C265.406 29.6845 265.583 28.9944 265.594 28.0413V27.7834C265.594 26.6949 265.417 25.9215 265.062 25.4631C264.708 25.0048 264.154 24.7756 263.398 24.7756C262.753 24.7756 262.255 25.0387 261.906 25.5647C261.557 26.0855 261.383 26.8303 261.383 27.7991C261.383 28.7574 261.552 29.4892 261.891 29.9944C262.229 30.4944 262.737 30.7444 263.414 30.7444Z"
              fill="#002A85"
            />
            <path
              d="M6 2.07251H286V0.0725098H6V2.07251ZM290 6.07251V46.0725H292V6.07251H290ZM286 50.0725H5.99999V52.0725H286V50.0725ZM2 46.0725V6.07251H0V46.0725H2ZM5.99999 50.0725C3.79086 50.0725 2 48.2817 2 46.0725H0C0 49.3862 2.68628 52.0725 5.99999 52.0725V50.0725ZM290 46.0725C290 48.2816 288.209 50.0725 286 50.0725V52.0725C289.314 52.0725 292 49.3862 292 46.0725H290ZM286 2.07251C288.209 2.07251 290 3.86337 290 6.07251H292C292 2.7588 289.314 0.0725098 286 0.0725098V2.07251ZM6 0.0725098C2.68629 0.0725098 0 2.7588 0 6.07251H2C2 3.86337 3.79086 2.07251 6 2.07251V0.0725098Z"
              fill="#002A85"
            />
          </svg>
          <svg
            v-if="node == '0'"
            @click="saveForLate()"
            class="page__header--info__icon show__btn"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.5 11C11.3674 11 11.2402 11.0527 11.1464 11.1464C11.0527 11.2402 11 11.3674 11 11.5V18.5C11 18.6326 11.0527 18.7598 11.1464 18.8536C11.2402 18.9473 11.3674 19 11.5 19H18.5C18.6326 19 18.7598 18.9473 18.8536 18.8536C18.9473 18.7598 19 18.6326 19 18.5V13.2071L16.7929 11H11.5ZM10.4393 10.4393C10.7206 10.158 11.1022 10 11.5 10H17C17.1326 10 17.2598 10.0527 17.3536 10.1464L19.8536 12.6464C19.9473 12.7402 20 12.8674 20 13V18.5C20 18.8978 19.842 19.2794 19.5607 19.5607C19.2794 19.842 18.8978 20 18.5 20H11.5C11.1022 20 10.7206 19.842 10.4393 19.5607C10.158 19.2794 10 18.8978 10 18.5V11.5C10 11.1022 10.158 10.7206 10.4393 10.4393Z"
              fill="#002A85"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 15.5C12 15.2239 12.2239 15 12.5 15H17.5C17.7761 15 18 15.2239 18 15.5V19.5C18 19.7761 17.7761 20 17.5 20C17.2239 20 17 19.7761 17 19.5V16H13V19.5C13 19.7761 12.7761 20 12.5 20C12.2239 20 12 19.7761 12 19.5V15.5Z"
              fill="#002A85"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.5 10C12.7761 10 13 10.2239 13 10.5V12.5H16.5C16.7761 12.5 17 12.7239 17 13C17 13.2761 16.7761 13.5 16.5 13.5H12.5C12.2239 13.5 12 13.2761 12 13V10.5C12 10.2239 12.2239 10 12.5 10Z"
              fill="#002A85"
            />
            <path
              d="M6 1.5H24V0.5H6V1.5ZM28.5 6V24H29.5V6H28.5ZM24 28.5H6V29.5H24V28.5ZM1.5 24V6H0.5V24H1.5ZM6 28.5C3.51472 28.5 1.5 26.4853 1.5 24H0.5C0.5 27.0376 2.96243 29.5 6 29.5V28.5ZM28.5 24C28.5 26.4853 26.4853 28.5 24 28.5V29.5C27.0376 29.5 29.5 27.0376 29.5 24H28.5ZM24 1.5C26.4853 1.5 28.5 3.51472 28.5 6H29.5C29.5 2.96243 27.0376 0.5 24 0.5V1.5ZM6 0.5C2.96243 0.5 0.5 2.96243 0.5 6H1.5C1.5 3.51472 3.51472 1.5 6 1.5V0.5Z"
              fill="#002A85"
            />
          </svg>
        </div>

        <div class="body__form--subscription">
          <div class="subscription__section">
            <div class="hide__subscription-section">
              <div class="card">
                <div class="card-body">
                  <div class="step__voyage">
                    <div class="step__voyage--item">
                      <div
                        class="custom__badge_default"
                        :class="step === 1 ? 'custom__badge--active' : ''"
                      >
                        1
                      </div>
                      <div
                        class="badge__text"
                        :class="step === 1 ? 'badge__text--active--active' : ''"
                      >
                        Informations
                      </div>
                    </div>
                    <hr />
                    <div class="step__voyage--item">
                      <div
                        class="custom__badge_default"
                        :class="step === 2 ? 'custom__badge--active' : ''"
                      >
                        2
                      </div>
                      <div
                        class="badge__text"
                        :class="step === 2 ? 'badge__text--active--active' : ''"
                      >
                        Fichiers joints
                      </div>
                    </div>
                    <hr />
                    <div class="step__voyage--item">
                      <div
                        class="custom__badge_default"
                        :class="step === 3 ? 'custom__badge--active' : ''"
                      >
                        3
                      </div>
                      <div
                        class="badge__text"
                        :class="step === 3 ? 'badge__text--active--active' : ''"
                      >
                        Résultat
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="card">
                <div class="card-body">
                  <div class="custom__badge-section d-md-none">
                    <div
                      class="custom__badge_default"
                      :class="step === 1 ? 'custom__badge--active' : ''"
                    >
                      1
                    </div>
                    <div
                      class="custom__badge_default"
                      :class="step === 2 ? 'custom__badge--active' : ''"
                    >
                      2
                    </div>
                    <div
                      class="custom__badge_default"
                      :class="step === 3 ? 'custom__badge--active' : ''"
                    >
                      3
                    </div>
                  </div>

                  <!-- ici le debut -->
                  <div v-if="['2', '3'].includes(node) && step === 1">
                    <h4 class="mb-4">Informations clients</h4>
                    <div class="form-row">
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Nom du client</label>
                          <span class="required">*</span>
                          <input
                            v-model="form.data.client_name"
                            type="text"
                            class="form-control"
                            required
                          />
                          <div v-if="errors.client_name" style="color: red">
                            {{ errors.client_name[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Prénom(s) du client</label>
                          <span class="required">*</span>
                          <input
                            v-model="form.data.client_firstname"
                            type="text"
                            class="form-control"
                            required
                          />
                          <div v-if="errors.client_firstname" style="color: red">
                            {{ errors.client_firstname[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Numéro de téléphone</label>
                          <span class="required">*</span>
                          <input
                            v-model="form.data.client_phone"
                            type="number"
                            min="0"
                            class="form-control"
                            required
                          />
                          <div v-if="errors.client_phone" style="color: red">
                            {{ errors.client_phone[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Email</label>
                          <input
                            v-model="form.data.client_email"
                            type="email"
                            class="form-control"
                          />
                          <div v-if="errors.client_email" style="color: red">
                            {{ errors.client_email[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- fin ici -->

                  <h4 class="mb-4">{{ titleStep() }}</h4>
                  <div v-if="step === 1">
                    <div class="form-row">
                      <div class="col-md-6 col-12">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              checked
                              @click="single()"
                              type="radio"
                              class="form-check-input"
                              name="optradio"
                            />Souscription individuelle
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-check">
                          <label class="form-check-label">
                            <input
                              @click="group()"
                              type="radio"
                              class="form-check-input"
                              name="optradio"
                            />Souscription de groupe
                          </label>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Nom</label>
                          <span class="required">*</span>
                          <input
                            v-model="form.data.last_name"
                            type="text"
                            class="form-control"
                            required
                          />
                          <div v-if="errors.last_name" style="color: red">
                            {{ errors.last_name[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Prénom(s)</label>
                          <span class="required">*</span>
                          <input
                            v-model="form.data.first_name"
                            type="text"
                            class="form-control"
                            required
                          />
                          <div v-if="errors.first_name" style="color: red">
                            {{ errors.first_name[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-12" v-if="auth.profile == 2">
                        <div class="form-group">
                          <label class="form__label">Intermédiaire associé</label>
                          <select
                            v-model="form.data.sale_code"
                            @change="getSalePoint()"
                            class="form-control"
                            required
                          >
                            <option value="">Selectionner</option>
                            <option
                              v-for="(item, key) in intermediaires"
                              :key="key"
                              :value="item.sale_code"
                            >
                              {{ item.nom_entreprise ? item.nom_entreprise : item.last_name + ' ' + item.first_name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-8 col-12">
                        <div class="row">
                          <div class="col-md-5 col-12">
                            <div class="form-group">
                              <label class="form__label">N° de passeport</label>
                              <span class="required">*</span>
                              <input
                                v-model="form.data.passport_number"
                                type="text"
                                class="form-control"
                                required
                              />
                              <div
                                v-if="errors.passport_number"
                                style="color: red"
                              >
                                {{ errors.passport_number[0] }}
                              </div>
                            </div>
                          </div>
                          <div class="col-md-7 col-12">
                            <div class="form-group">
                              <label class="form__label"
                                >Date d'expiration</label
                              >
                              <span class="required">*</span>
                              <input
                                v-model="form.data.expiring_date"
                                type="date"
                                :min="today"
                                class="form-control"
                                required
                              />
                              <div
                                v-if="errors.expiring_date"
                                style="color: red"
                              >
                                {{ errors.expiring_date[0] }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-12">
                        <div class="form-group">
                          <label class="form__label">Tranche d'âges</label>
                          <span class="required">*</span>
                          <select
                            @change="() => {
                              if(form.data.destination_area) {
                                getDurations()
                              }
                            }"
                            v-model="form.data.birthday"
                            class="form-control"
                            required
                          >
                            <option value="">Selectionner</option>
                            <option
                              v-for="(item, key) in ages_section"
                              :key="key"
                              :value="item.description"
                            >
                              {{ item.description }}
                            </option>
                          </select>
                          <div v-if="errors.birthday" style="color: red">
                            {{ errors.birthday[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-12">
                        <div class="form-group">
                          <label class="form__label">Date de naissance</label>
                          <span class="required">*</span>
                          <input :max="today" v-model="form.data.date_nais" type="date" class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4 col-12">
                        <div class="form-group">
                          <label class="form__label">Date départ</label>
                          <span class="required">*</span>
                          <input @change="() => form.data.date_end = ``" v-model="form.data.date_begin" type="date" :min="today"
                            class="form-control" />
                          <div v-if="errors.date_begin" style="color: red">
                            {{ errors.date_begin[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 col-12">
                        <div class="form-group">
                          <label class="form__label">Date retour</label>
                          <span class="required">*</span>
                          <input v-model="form.data.date_end" type="date" :min="form.data.date_begin" class="form-control" :disabled="!form.data.date_begin" />
                          <div v-if="errors.date_end" style="color: red">
                            {{ errors.date_end[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label class="form__label">Zone de destination</label>
                          <span class="required">*</span>
                          <select
                            v-model="form.data.destination_area"
                            @change="getDurations()"
                            class="form-control"
                            required
                          >
                            <option value="">Selectionner</option>
                            <option
                              v-for="(item, key) in zone_section"
                              :key="key"
                              :value="item.name"
                            >
                              {{ item.name }}
                            </option>
                          </select>
                          <div
                            v-if="errors.destination_area"
                            style="color: red"
                          >
                            {{ errors.destination_area[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label">Produit</label>
                          <span class="required" v-if="products.length">*</span>
                          <select
                            v-model="form.data.product"
                            class="form-control"
                            :required="products.length"
                          >
                            <option value="">Selectionner</option>
                            <option
                              v-for="(item, key) in products"
                              :key="key"
                              :value="item.description"
                            >
                             {{ item.description }}
                            </option>
                          </select>
                          <div
                            v-if="errors.destination_area"
                            style="color: red"
                          >
                            {{ errors.destination_area[0] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                        <div class="form-group">
                          <label class="form__label"
                            >Durée du voyage (jours)</label
                          >
                          <span class="required">*</span>
                          <select
                            v-model="form.data.travel_time"
                            class="form-control"
                            required
                          >
                            <option value="">Selectionner</option>
                            <option
                              v-for="(item, key) in durations"
                              :key="key"
                              :value="item.description"
                            >
                              {{ item.description }}
                            </option>
                          </select>
                          <div v-if="errors.travel_time" style="color: red">
                            {{ errors.travel_time[0] }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="form.data.other_people.length > 0">
                      <div
                        v-for="(item, key) in form.data.other_people"
                        :key="key"
                        class="form-row"
                      >
                        <div class="col-12">
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.5 6.48251L18.09 5.07251L12.5 10.6625L6.91 5.07251L5.5 6.48251L11.09 12.0725L5.5 17.6625L6.91 19.0725L12.5 13.4825L18.09 19.0725L19.5 17.6625L13.91 12.0725L19.5 6.48251Z"
                              fill="#E73D3E"
                            />
                          </svg>
                          <span @click="removeUser(item)" class="delete__user"
                            >Supprimer cet assuré</span
                          >
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label class="form__label">Nom</label>
                            <span class="required">*</span>
                            <input
                              v-model="item.last_name"
                              type="text"
                              class="form-control"
                              required
                            />
                            <div
                              v-if="
                                errors['other_people.' + key + '.last_name']
                              "
                              style="color: red"
                            >
                              {{
                                errors["other_people." + key + ".last_name"][0]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label class="form__label">Prénom(s)</label>
                            <span class="required">*</span>
                            <input
                              v-model="item.first_name"
                              type="text"
                              class="form-control"
                              required
                            />
                            <div
                              v-if="
                                errors['other_people.' + key + '.first_name']
                              "
                              style="color: red"
                            >
                              {{
                                errors["other_people." + key + ".first_name"][0]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-8 col-12">
                          <div class="row">
                            <div class="col-md-5 col-12">
                              <div class="form-group">
                                <label class="form__label"
                                  >N° de passeport</label
                                >
                                <span class="required">*</span>
                                <input
                                  v-model="item.passport_number"
                                  type="text"
                                  class="form-control"
                                  required
                                />
                                <div
                                  v-if="
                                    errors[
                                      'other_people.' + key + '.passport_number'
                                    ]
                                  "
                                  style="color: red"
                                >
                                  {{
                                    errors[
                                      "other_people." + key + ".passport_number"
                                    ][0]
                                  }}
                                </div>
                              </div>
                            </div>
                            <div class="col-md-7 col-12">
                              <div class="form-group">
                                <label class="form__label"
                                  >Date d'expiration</label
                                >
                                <span class="required">*</span>
                                <input
                                  v-model="item.expiring_date"
                                  type="date"
                                  :min="today"
                                  class="form-control"
                                  required
                                />
                                <div
                                  v-if="
                                    errors[
                                      'other_people.' + key + '.expiring_date'
                                    ]
                                  "
                                  style="color: red"
                                >
                                  {{
                                    errors[
                                      "other_people." + key + ".expiring_date"
                                    ][0]
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <label class="form__label">Tranche d'âges</label>
                            <span class="required">*</span>
                            <select
                              @change="() => {
                                if(item.destination_area) {
                                  getDurationsChild(item)
                                }
                              }"
                              v-model="item.birthday"
                              class="form-control"
                              required
                            >
                              <option value="">Selectionner</option>
                              <option
                                v-for="(item, key) in item.ages_section"
                                :key="key"
                                :value="item.description"
                              >
                                {{ item.description }}
                              </option>
                            </select>
                            <div
                              v-if="errors['other_people.' + key + '.birthday']"
                              style="color: red"
                            >
                              {{
                                errors["other_people." + key + ".birthday"][0]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <label class="form__label">Date de naissance</label>
                            <span class="required">*</span>
                            <input :max="today" v-model="item.date_nais" type="date" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <label class="form__label">Date départ</label>
                            <span class="required">*</span>
                            <input @change="() => item.date_end = ``" v-model="item.date_begin" type="date" :min="today"
                              class="form-control" />
                            <div v-if="errors.date_begin" style="color: red">
                              {{ errors.date_begin[0] }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 col-12">
                          <div class="form-group">
                            <label class="form__label">Date retour</label>
                            <span class="required">*</span>
                            <input v-model="item.date_end" type="date" :min="item.date_begin" class="form-control" :disabled="!item.date_begin" />
                            <div v-if="errors.date_end" style="color: red">
                              {{ errors.date_end[0] }}
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group">
                            <label class="form__label"
                              >Zone de destination</label
                            >
                            <span class="required">*</span>
                            <select
                              @change="getDurationsChild(item)"
                              v-model="item.destination_area"
                              class="form-control"
                              required
                            >
                              <option value="">Selectionner</option>
                              <option
                                v-for="(zone, key) in item.zone_section"
                                :key="key"
                                :value="zone.name"
                              >
                                {{ zone.name }}
                              </option>
                            </select>
                            <div
                              v-if="
                                errors[
                                  'other_people.' + key + '.destination_area'
                                ]
                              "
                              style="color: red"
                            >
                              {{
                                errors[
                                  "other_people." + key + ".destination_area"
                                ][0]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label class="form__label">Produit</label>
                            <span class="required" v-if="products.length">*</span>
                            <select
                              v-model="form.data.other_people[key].product"
                              class="form-control"
                              required
                            >
                              <option value="">Selectionner</option>
                              <option
                                v-for="(product, key) in item.products"
                                :key="key"
                                :value="product.description"
                              >
                                {{ product.description }}
                              </option>
                            </select>
                            <div
                              v-if="errors.destination_area"
                              style="color: red"
                            >
                              {{ errors.destination_area[0] }}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-12">
                          <div class="form-group">
                            <label class="form__label"
                              >Durée du voyage (jours)</label
                            >
                            <span class="required">*</span>
                            <select
                              v-model="item.travel_time"
                              class="form-control"
                              required
                            >
                              <option value="">Selectionner</option>
                              <option
                                v-for="(duration, key) in item.durations"
                                :key="key"
                                :value="duration.description"
                              >
                                {{ duration.description }}
                              </option>
                            </select>
                            <div
                              v-if="errors['other_people.' + key + '.duration']"
                              style="color: red"
                            >
                              {{
                                errors["other_people." + key + ".duration"][0]
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="element === 1">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.5 8.07251H8.5V14.0725H6.5V8.07251H0.5V6.07251H6.5V0.0725098H8.5V6.07251H14.5V8.07251Z"
                          fill="#002A85"
                        />
                      </svg>
                      <span @click="addUser()" class="user__add"
                        >Ajouter un assuré</span
                      >
                    </div>
                  </div>
                  <div v-show="step === 2">
                    <p>
                      Veuillez charger le(s) fichier(s) requis :
                      <span style="color: #d09a12">copie du passeport.</span>
                    </p>
                    <file-upload
                      ref="upload"
                      :acceptFile="'.jpg,.png,.gif,.jpeg,.pdf,.doc,.docx,.xls,.xlsx'"
                    />
                  </div>
                  <div v-if="step === 3">
                    <div class="detail__sup">
                      <div class="section__information">
                        <div class="section__information-text">Prime nette</div>
                        <div class="section__information-dote"></div>
                        <div class="section__information-price">
                          {{ summary.net ? $format(summary.net) + " Fcfa" : 0 + " Fcfa" }}
                        </div>
                      </div>

                      <div v-if="summary.summary && summary.summary.length > 0">
                        <div v-for="(person, idx) in summary.summary" :key="idx" class="mb-3 border-bottom pb-2">
                           <small class="font-weight-bold">{{ person.name }}</small>
                           <div class="d-flex justify-content-between">
                              <span>Net</span>
                              <span>{{ $format(person.net) }} Fcfa</span>
                           </div>
                           <div v-if="person.reduction" class="d-flex justify-content-between text-success">
                              <span>Réduction</span>
                              <span>-{{ $format(person.reduction) }} Fcfa</span>
                           </div>
                        </div>
                      </div>

                      <div class="section__information">
                        <div class="section__information-text">Taxes</div>
                        <div class="section__information-dote"></div>
                        <div class="section__information-price">{{ $format(Math.round(summary.tax)) }} Fcfa</div>
                      </div>



                      <div class="section__amount d-flex justify-content-between mt-3">
                        <div class="section__amount-text">Total à payer</div>
                        <div class="section__amount-price">
                          {{ summary.total ? $format(Math.round(summary.total)) + " Fcfa" : 0 + " Fcfa" }}
                        </div>
                      </div>
                    </div>
                  </div>
                    <div v-if="node == '0'" class="section__neg" @click="saveNegotiated()">
                      <svg
                        width="19"
                        height="20"
                        viewBox="0 0 19 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.50065 2.57255C5.35851 2.57255 2.00065 5.93041 2.00065 10.0725C2.00065 14.2147 5.35851 17.5725 9.50065 17.5725C13.6428 17.5725 17.0006 14.2147 17.0006 10.0725C17.0006 5.93041 13.6428 2.57255 9.50065 2.57255ZM0.333984 10.0725C0.333984 5.00994 4.43804 0.905884 9.50065 0.905884C14.5633 0.905884 18.6673 5.00994 18.6673 10.0725C18.6673 15.1352 14.5633 19.2392 9.50065 19.2392C4.43804 19.2392 0.333984 15.1352 0.333984 10.0725Z"
                          fill="#002A85"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.50065 9.23922C9.96089 9.23922 10.334 9.61231 10.334 10.0725V13.4059C10.334 13.8661 9.96089 14.2392 9.50065 14.2392C9.04041 14.2392 8.66732 13.8661 8.66732 13.4059V10.0725C8.66732 9.61231 9.04041 9.23922 9.50065 9.23922Z"
                          fill="#002A85"
                        />
                        <path
                          d="M10.334 6.73922C10.334 7.19945 9.96089 7.57255 9.50065 7.57255C9.04041 7.57255 8.66732 7.19945 8.66732 6.73922C8.66732 6.27898 9.04041 5.90588 9.50065 5.90588C9.96089 5.90588 10.334 6.27898 10.334 6.73922Z"
                          fill="#002A85"
                        />
                      </svg>
                      <span class="section__neg-text"
                        >Demander une négociation</span
                      >
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="button__footer">
                    <button
                      @click="prevStep()"
                      :disabled="step === 1"
                      class="btn btn-default__cancel mr-2"
                    >
                      Retour
                    </button>
                    <button
                      class="btn btn-primary__save"
                      :class="loading ? 'disabled' : ''"
                      @click="saveAssurance()"
                    >
                      {{ getText() }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="payment__info">
      <div class="payment__info--text">Moyens de paiement acceptés</div>
      <div class="payment__widget">
        <img :src="$assets('images/payment.png')" width="140" alt="payment" />
      </div>
    </div>
    <div class="voyage__info">
      <div
        class="happy__young"
        :style="`background: url(${$assets(
          'images/young.png'
        )}) no-repeat center;background-size: cover;`"
      ></div>
      <div class="hire__me">
        <div class="background__info">
          <div class="svg__hire">
            <svg
              width="188"
              height="188"
              viewBox="0 0 188 188"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M187.6 63.3316C187.6 78.2084 182.026 91.8455 172.801 102.59C174.531 107.549 177.606 113.128 183.372 117.053C184.717 118.087 184.333 120.359 182.603 120.566C176.645 121.393 166.65 121.599 157.233 115.607C152.428 118.5 147.239 120.773 141.665 122.632C140.127 83.374 106.493 51.7607 65.5547 51.7607C62.2874 51.7607 59.02 51.9674 55.9449 52.3806C61.5186 23.0402 88.6184 0.724976 121.292 0.724976C157.809 0.724976 187.6 28.8256 187.6 63.3316ZM12.7005 162.097C4.82044 151.559 0.399902 138.955 0.399902 125.938C0.399902 91.6389 29.6139 63.9515 65.3625 63.9515C101.303 63.9515 130.325 91.8455 130.325 125.938C130.325 160.238 101.111 187.925 65.3625 187.925C54.0229 187.925 42.8755 185.032 33.0734 179.66C27.8841 182.346 22.1182 183.586 15.9679 183.586C13.8537 183.586 11.7395 183.379 9.62537 183.173C6.55021 182.759 4.24385 180.28 3.47506 177.181C2.89847 173.875 4.05165 170.775 6.55021 168.916C9.24097 167.263 11.1629 164.99 12.7005 162.097ZM23.4636 156.932L25.7699 159.618L24.6167 163.13C23.6558 166.023 22.3104 168.916 20.5806 171.189C24.2323 170.569 27.4997 169.329 30.3827 167.469L33.2656 165.61L36.1486 167.263C44.9896 172.635 55.1761 175.528 65.5547 175.528C95.1531 175.528 119.37 153.212 119.37 125.525C119.37 97.8375 95.1531 75.5223 65.5547 75.5223C35.9564 75.5223 11.7395 97.8375 11.7395 125.525C11.7395 137.302 15.7757 148.047 23.4636 156.932ZM67.2845 112.094C71.1284 112.094 74.3958 108.582 74.3958 104.243C74.3958 99.9038 71.3206 96.3912 67.2845 96.3912C63.2484 96.3912 59.981 99.9038 59.981 104.036C59.981 108.582 63.2484 112.094 67.2845 112.094ZM54.5995 119.326C55.3683 119.533 56.1371 119.74 56.9059 119.74C58.8278 119.946 59.4044 120.773 59.4044 122.839C59.4044 123.045 59.4044 123.459 59.4044 123.665C58.6356 128.418 57.8668 133.377 57.0981 138.129C56.7137 140.815 56.3293 143.708 55.9449 146.6C55.3683 150.733 59.02 154.452 61.903 155.072C63.6328 155.279 65.3625 155.485 67.0923 155.279C70.9362 155.279 74.0114 153.419 76.7022 150.733C77.0866 150.32 77.471 149.493 77.6632 148.873C77.8553 147.634 77.0866 147.014 75.9334 147.427C75.1646 147.634 74.588 148.253 73.8192 148.46C72.8582 148.873 72.0894 149.08 71.1284 149.287C69.9753 149.493 69.2065 148.873 69.0143 147.634C68.8221 146.807 68.6299 145.774 68.8221 144.947C69.0143 143.088 69.3987 141.228 69.5909 139.369C70.5519 133.79 71.5128 128.211 72.4738 122.839C72.666 121.393 73.0504 119.74 72.8582 118.293C72.8582 116.434 71.8972 115.607 70.1675 115.607C67.8611 115.607 65.5547 115.607 63.0562 115.607C60.942 115.607 58.6356 115.607 56.5215 115.607C55.9449 115.607 55.3683 115.607 54.7917 115.814C53.8307 116.02 53.2541 116.64 53.2541 117.467C53.2541 118.087 53.6385 118.913 54.5995 119.326Z"
                fill="#E8EFFF"
              />
            </svg>
          </div>
          <div class="hire__me--text">Contactez-nous</div>
          <div class="hire__me--description">
            Si vous avez des questions ou rencontrez une difficulté, contactez-nous au {{ settings.support_phone }} ou envoyez-nous un e-mail à {{ settings.support_email }}
          </div>
          <div class="hire__me--button">
            <button class="btn btn-secondary">Parler à un expert</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="comments"
      tabindex="-1"
      role="dialog"
      aria-labelledby="comments"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #fff !important">
            <h5 class="modal-title" id="comments">
              Négociation de l'assurance Voyage n° {{ id }}
            </h5>
            <button
              type="button"
              class="close"
              @click="closeModal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: #f8f8f8 !important">
            <div class="chat-box">
              <div
                :class="!comment.is_customer ? 'chat' : 'chat-left'"
                class="mb-2"
                v-for="(comment, key) in comments"
                :key="key"
              >
                {{ comment.message }}
              </div>
            </div>
          </div>
          <div class="modal-footer grid-item">
            <input
              @keyup.enter="sendComment"
              :class="sending ? 'error' : ''"
              v-model="comment.message"
              type="text"
              class="form-control message"
              placeholder="Tapez votre message"
            />
            <button @click="sendComment" type="button" class="btn btn-primary">
              Envoyer
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { api } from "../../helpers/shared";
import moment from "moment";
import fileUpload from "../../components/upload/FileUpload.vue";
import { Zones, Ages, Durations, Prices, Products } from '../../../constants'

let loader = null;
export default {
  name: "voyage-subscription",
  props: ["ages", "node"],
  components: { fileUpload },
  watch: {
    step: function (val) {
      this.form.step = val;
    },
  },
  data: () => ({
    errors: [],
    ages_section: [],
    zone_section: [],
    durations: [],
    products: [],
    intermediaires: [],
    auth: {},
    step: 1,
    element: 0,
    loading: false,
    summary: {
      net: 0,
      tax: 0,
      fees: 0,
      total: 0,
      summary: []
    },
    today: "",
    files: [],
    form: {
      step: 1,
      amount: 0,
      product_id: 3,
      data: {
        product: "",
        number_of_people_to_be_insured: "",
        expiring_date: "",
        first_name: "",
        last_name: "",
        sale_code: "",
        sale_point: "",
        name: "",
        email: "",
        address: "",
        phone: "",
        date_nais: "",
        date_begin: "",
        date_end: "",
        other_people: [],
        birthday: "",
        passport_number: "",
        destination_area: "",
        travel_time: "",
        client_name: "",
        client_firstname: "",
        client_phone: "",
        client_email: "",
      },
    },
    comment: {
      message: "",
      uuid: "",
      id: "",
    },
    sending: false,
    comments: [],
    uuid: "",
    id: "",
  }),
  mounted() {
    this.ages_section = Ages
    this.zone_section = Zones
    this.getIntermediairesWithSaleCode()
    this.auth = JSON.parse(localStorage.getItem('auth')).user
    this.today = moment(new Date()).format("YYYY-MM-DD");
  },

  methods: {
    getSalePoint() {
      const intermediaire = this.intermediaires.find(item => item.sale_code === this.form.data.sale_code)

      if(intermediaire) {
        this.form.data.sale_point = intermediaire.nom_entreprise ? intermediaire.nom_entreprise : intermediaire.last_name + ' ' + intermediaire.first_name
      }
    },
    getIntermediairesWithSaleCode() {
      axios
        .get(api("intermediaires"))
        .then((response) => {
          this.intermediaires = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendComment() {
      if (this.comment.message != "") {
        this.sending = false;
        this.comment.uuid = this.uuid;
        this.comment.id = this.id;
        axios.post(api("subscription/add/message"), this.comment);
        this.comment.message = "";
      } else this.sending = true;
    },
    closeModal() {
      this.$document("#comments").modal("hide");
      setTimeout(() => {
        window.location.reload();
      }, 200);
    },
    showComments() {
      db.collection(this.uuid)
        .orderBy("createdAt")
        .onSnapshot((querySnapshot) => {
          let comments = [];
          querySnapshot.forEach((doc) => {
            comments.push(doc.data());
          });
          this.comments = comments;
        });
    },
    saveForLate() {
      if (
        Object.keys(this.summary).length === 0 &&
        this.summary.constructor === Object
      ) {
        this.$toasted.global.error({
          message: "Vous devez completer la première étape",
        });
      } else {
        loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        this.form.amount = this.summary.total;
        axios
          .post(api("subscription/save-for-late"), this.form)
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.$toasted.global.all({
                message: "La souscription a été enrégistrée",
              });
              setTimeout(() => {
                window.location.reload();
              }, 400);
            } else this.$toasted.global.error();
          })
          .catch((error) => {
            loader.hide();
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
            } else
              this.$toasted.global.error({
                message:
                  "Vous devez vous connecter pour procéder à cette opération",
              });
          });
      }
    },
    saveNegotiated() {
      loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#4B4B4B",
        backgroundColor: "#4B4B4B",
        height: 35,
        width: 35,
        loader: "bars",
        opacity: 0.3,
      });
      this.form.amount = this.summary.total;
      axios
        .post(api("subscription/negotiated"), this.form)
        .then((response) => {
          if (response.data.status) {
            let content = response.data;
            this.uuid = content.uuid;
            this.id = content.id;
            this.showComments();
            setTimeout(() => {
              this.$document("#comments").modal("show");
              loader.hide();
            }, 400);
          } else {
            loader.hide();
            this.$toasted.global.error();
          }
        })
        .catch((error) => {
          loader.hide();
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          } else
            this.$toasted.global.error({
              message:
                "Vous devez vous connecter pour procéder à cette opération",
            });
        });
    },
    checkAmount() {
      axios
        .post(api("bills"), { bill: "voyage", data: this.form.data })
        .then((response) => {
          this.loading = false;
          console.log(response);
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
          this.loading = false;
        });
    },

    saveAssurance() {
      switch (this.step) {
        case 3:
          this.addBasket();
          break;
        case 1:
          axios
            .post(api("assurances/voyage/save"), this.form)
            .then((response) => {
              this.loading = false;
              if (response.data.status) {
                this.summary = response.data.content;
                this.form.amount = this.summary.total;
                this.nextStep();
              } else {
                this.$toasted.global.error();
              }
            })
            .catch((error) => {
              console.log(error)
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                if (typeof this.errors !== 'object') {
                  this.$toasted.global.error({
                    message: this.errors,
                  });
                }
              }
              this.loading = false;
            });
          break
        default:
          this.nextStep();
          break;
      }
      // else {
      //   if (this.step === 1) {
      //     // loader = this.$loading.show({
      //     //   container: null,
      //     //   canCancel: false,
      //     //   color: "#4B4B4B",
      //     //   backgroundColor: "#4B4B4B",
      //     //   height: 35,
      //     //   width: 35,
      //     //   loader: "bars",
      //     //   opacity: 0.3,
      //     // });
      //     // this.loading = true;
      //     // axios
      //     //   .post(api("assurances/voyage/save"), this.form)
      //     //   .then((response) => {
      //     //     this.loading = false;
      //     //     loader.hide();
      //     //     if (response.data.status) {
      //     //       this.summary = response.data.content;
      //     //       this.errors = [];
      //     //       this.nextStep();
      //     //     } else {
      //     //       this.$toasted.global.error();
      //     //     }
      //     //   })
      //     //   .catch((error) => {
      //     //     loader.hide();
      //     //     if (error.response.status === 422) {
      //     //       this.errors = error.response.data.errors;
      //     //     }
      //     //     this.loading = false;
      //     //   });
      //   } else {
      //     this.nextStep();
      //   }
      // }
    },
    getDurationsChild(item) {
      if (!item.destination_area) return

      if (item.destination_area === 'Europe - Schengen Exclusif' || item.destination_area === 'Europe et Schengen' || item.destination_area === "Monde Entier (excepté le pays de résidence de l'assuré(e))") {
        item.durations = Durations.filter(item => item.zone_id === '1-2-3')
      }
      
      if(item.destination_area === 'Monde Entier') {
        item.durations = Durations.filter(item => item.zone_id === 4)
      }
      
      if(item.destination_area === "Monde Entier (excepté le Nigéria et le pays de résidence de l'assuré(e))") {
        item.durations = Durations.filter(item => item.zone_id === 5)
      }

      // Update products
      const zone = Zones.find(zone => zone.name === item.destination_area)
      
      if(zone) item.products = Products.filter(el => el.zone_id === zone.id)

      if(item.destination_area === "Monde Entier (excepté le pays de résidence de l'assuré(e))" && item.birthday !== 'De 19 ans à 65 ans') {
        item.products = this.products.filter(item => item.age_id !== 2)
      }
    },
    getDurations() {
      if(!this.form.data.destination_area) return

      if (this.form.data.destination_area === 'Europe - Schengen Exclusif' || this.form.data.destination_area === 'Europe et Schengen' || this.form.data.destination_area === "Monde Entier (excepté le pays de résidence de l'assuré(e))") {
        this.durations = Durations.filter(item => item.zone_id === '1-2-3')
      }

      if(this.form.data.destination_area === 'Monde Entier') {
        this.durations = Durations.filter(item => item.zone_id === 4)
      }

      if(this.form.data.destination_area === "Monde Entier (excepté le Nigéria et le pays de résidence de l'assuré(e))") {
        this.durations = Durations.filter(item => item.zone_id === 5)
      }

      // Update products
      const zone = Zones.find(item => item.name === this.form.data.destination_area)

      if(zone) this.products = Products.filter(item => item.zone_id === zone.id)

      if(this.form.data.destination_area === "Monde Entier (excepté le pays de résidence de l'assuré(e))" && this.form.data.birthday !== 'De 19 ans à 65 ans') {
        this.products = this.products.filter(item => item.age_id !== 2)
      }
      
    },
    single() {
      this.element = 0;
      this.form.data.other_people = [];
    },
    group() {
      this.element = 1;

      this.form.data.other_people.push({
        name: "",
        last_name: "",
        first_name: "",
        birthday: "",
        expiring_date: "",
        passport_number: "",
        destination_area: "",
        date_nais: "",
        date_begin: "",
        date_end: "",
        travel_time: "",
        zone_section: Zones,
        ages_section: Ages,
        durations: [],
        products: [],
        product: ""
      });
    },
    addUser() {
      this.form.data.other_people.push({
        name: "",
        last_name: "",
        first_name: "",
        birthday: "",
        date_nais: "",
        date_begin: "",
        date_end: "",
        passport_number: "",
        destination_area: "",
        travel_time: "",
        zone_section: Zones,
        ages_section: Ages,
        durations: [],
        products: [],
        product: ""
      });
    },
    removeUser(element) {
      if (this.form.data.other_people.length > 1) {
        let index = this.form.data.other_people.indexOf(element);
        this.form.data.other_people.splice(index, 1);
      } else {
        this.$toasted.global.error({
          message:
            "En selectionnant l'option groupe, vous devez ajouter au moins un utilisateur",
        });
      }
    },
    nextStep() {
      if (this.step < 3) this.step++;
      if (this.step === 2) {
        this.$refs.upload.reloadView();
      }
    },
    prevStep() {
      if (this.step !== 1) this.step--;
      if (this.step === 2) {
        this.$refs.upload.reloadView();
      }
    },
    titleStep() {
      switch (this.step) {
        case 1:
          return "Informations";
        case 2:
          return "Fichiers joints";
        case 3:
          return "Résultat";
      }
    },
    getText() {
      switch (this.step) {
        case 1:
          return "Suivant";
        case 2:
          return "Suivant";
        case 3:
          return "Ajouter au panier";
      }
    },
    addBasket() {
      this.form.amount = this.summary.total
      if (this.$store.state.upload.files.length > 0) {
        loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        let form = new FormData();
        this.$store.state.upload.files.map((file, key) => {
          form.append("files[" + key + "]", file);
        });
        axios
          .post(api("administration/file/upload"), form, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.files = response.data.files;
              let carts = this.$storage.getItem("carts");
              if (carts) {
                let data = JSON.parse(this.$storage.decryptString(carts));
                data.push({
                  product: this.form,
                  detail: this.summary,
                  check: true,
                  files: this.files,
                  uuids: this.$uuid(),
                });
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(JSON.stringify(data))
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  this.$router("/pannier");
                }, 500);
              } else {
                const products = JSON.stringify([
                  {
                    product: this.form,
                    detail: this.summary,
                    check: true,
                    files: this.files,
                    uuids: this.$uuid(),
                  },
                ]);
                this.$storage.setItem(
                  "carts",
                  this.$storage.encryptString(products)
                );
                this.$toasted.global.all({
                  message: "Le produit est ajouté au panier",
                });
                setTimeout(() => {
                  this.$router("/pannier");
                }, 500);
              }
            } else this.$toasted.global.error();
          })
          .catch(() => {
            loader.hide();
            this.$toasted.global.error({
              message: "Impossible d'ajouter le produit au panier",
            });
          });
      } else {
        let carts = this.$storage.getItem("carts");
        if (carts) {
          let data = JSON.parse(this.$storage.decryptString(carts));
          data.push({
            product: this.form,
            detail: this.summary,
            check: true,
            uuids: this.$uuid(),
          });
          this.$storage.setItem(
            "carts",
            this.$storage.encryptString(JSON.stringify(data))
          );
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            window.location.href = "/pannier";
          }, 500);
        } else {
          const products = JSON.stringify([
            {
              product: this.form,
              detail: this.summary,
              check: true,
              uuids: this.$uuid(),
            },
          ]);
          this.$storage.setItem("carts", this.$storage.encryptString(products));
          this.$toasted.global.all({
            message: "Le produit est ajouté au panier",
          });
          setTimeout(() => {
            window.location.href = "/pannier";
          }, 500);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.breadcrumb {
  margin-left: -16px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background-color: #e8f1ff;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  font-size: 14px;
}
.page__header--info {
  display: grid;
  height: 60px;
  margin-bottom: 10px;
  grid-template-columns: 3fr 1fr;
  .page__header--info__text {
    color: #001e5f;
    font-size: 16px;
    line-height: 25px;
    letter-spacing: -0.3px;
    font-weight: bold;
    align-self: center;
  }
  .page__header--info__icon {
    place-self: center;
    cursor: pointer;
  }
}
.body__form--subscription {
}
.custom__badge_default {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: 3px solid #d6d6dc;
  color: #d6d6dc;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.step__voyage--item {
  display: grid;
  grid-template-columns: 1fr 240px;
  justify-content: center;
  align-items: center;
}
.custom__badge--active {
  background-color: #d39e0a;
  color: #ffffff;
  border: 3px solid #d39e0a !important;
}
.step__voyage {
  display: grid;
  grid-auto-flow: row;
  hr {
    border: 1px solid #d6d6dc;
    color: #d6d6dc;
    width: 310px;
  }
}
.form__label {
  color: #6e6b7b;
}
.badge__text {
  font-size: 19px;
  color: #6e6b7b;
}
.badge__text--active {
  color: #d39e0a;
}
.btn-default:focus,
.btn-default.focus {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-default__cancel {
  color: #fff;
  background-color: #b9b9c3;
  border-color: #b9b9c3;
}

.btn-primary__save {
  color: #fff !important;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}
.delete__user {
  color: #e73d3e;
  cursor: pointer;
}
.user__add {
  color: #001e5f;
  cursor: pointer;
}
.section__information {
  display: grid;
  grid-template-columns: 110px 2fr 110px;
  align-items: baseline;
  .section__information-dote {
    border-bottom: 1px dotted #000000;
  }
  .section__information-price {
    justify-self: end;
    color: #000000;
    font-weight: bold;
  }
  .section__information-text {
    color: #6e6b7b;
  }
}
.section__amount {
  display: grid;
  grid-template-columns: 5fr 1fr;
  .section__amount-text {
    justify-self: end;
    color: #6e6b7b;
  }
  .section__amount-price {
    justify-self: end;
    color: #ea5455;
  }
}
.show__btn {
  display: none;
}

.section__neg {
  cursor: pointer;
}
.section__neg-text {
  color: #002a85;
}

.custom__badge-section {
  display: grid;
  grid-template-columns: 50px 50px 50px;
  justify-content: start;
  align-items: center;
  height: 100px;
  grid-gap: 10px;
}

.subscription__section {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 30px;
}

.button__footer {
  display: grid;
  grid-template-columns: 200px 200px;
  justify-content: end;
}

@media only screen and (max-width: 500px) {
  .button__footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media only screen and (max-width: 870px) {
  .hide__subscription-section {
    display: none !important;
  }
  .subscription__section {
    display: grid;
    grid-template-columns: 1fr;
  }
}
@media only screen and (max-width: 992px) {
  .section__amount {
    grid-template-columns: 4fr 2fr;
  }
}
@media only screen and (max-width: 540px) {
  .show__btn {
    display: block;
  }
  .hide__on_mobile {
    display: none !important;
  }
  .hide__btn--large {
    display: none !important;
  }
  .page__header--info .page__header--info__icon {
    place-self: end;
    align-self: center;
  }
}
/*
    .total__info {
        display: grid;
        grid-template-columns: 130px 1fr;
        justify-content: center;
        align-items: center;
        .total__info--price{
            color: #000000;
            font-weight: bold;
        }
    }

     */
.grid-item {
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 5px;
  padding: 5px;
}
.chat {
  background-color: #fff;
  padding: 10px;
  height: auto;
  width: 80%;
  border-radius: 5px;
}
.chat-left {
  background: linear-gradient(
    46.62deg,
    #001e5f 0%,
    rgba(0, 30, 95, 0.8) 93.64%
  );
  border-radius: 5px;
  color: #fff;
  text-align: right;
  padding: 10px;
  height: auto;
  width: 80%;
  margin-left: 20%;
}
.error {
  border-color: red !important;
}
.btn-primary {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:hover {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:focus,
.btn-primary.focus {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
  box-shadow: 0 0 0 0.2rem #001e5f !important;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #001e5f !important;
  border-color: #001e5f !important;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem #001e5f !important;
}
.required {
  color: red;
}
</style>
